import React from "react";
import { LoaderWrapper } from "./styled";
import { helix } from "ldrs";
helix.register();

const GeneralLoading = () => {
  return (
    <LoaderWrapper>
      <l-helix size="120" speed="1.5" color="rgba(26, 126, 156, 1)"></l-helix>
    </LoaderWrapper>
  );
};

export default GeneralLoading;
